import { NAME as APP_NAME } from 'constants';
import * as I18n from 'circe/I18n';

export const NAME = `${APP_NAME}/ACCOUNT_ADMINS`;

export const REDUCER_NAME = 'accountAdmins';

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/accounts?type=SHIPPER`;

export const ROUTES = {
  ROOT: '/vendor-companies',
};

export const TABLE_NAME = I18n.str('vendorCompanies', 'Vendor Companies');
export const ACTION_NAME = I18n.str('createCompny', 'Create Company');
export const ITEM_KEY = 'vendorCompanies';

export const ACCOUNT_TYPE = 'SHIPPER';
